@if (loginDurationHtml(); as dynamicHtml) {
    <div class="login-duration user-login-duration" [ngClass]="{ 'login-duration-txt-empty': dynamicHtml === PLACEHOLDER_MESSAGE }">
        <span class="login-duration-text" [vnDynamicHtml]="dynamicHtml"></span>
    </div>
}
